// extracted by mini-css-extract-plugin
module.exports = {"foolScreen":"NewFoolScreen_foolScreen__2qBZ1","subscribersBlock":"NewFoolScreen_subscribersBlock__btBKY"};